<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/argkVo/tc-custom/9781611520798.jpg?1713839839101" alt="This image is the cover for the book Makin' Copies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Makin' Copies
      </h1>
      <p class="bookDescription body article font2">
        <p>At the office Christmas party, Johnson had a bit too much to drink and thought it'd be a hoot to photocopy his butt using the office copier machine.<br/><br/>It sounded like a cheap thrill at the time, but he forgot to snag the copies off the machine before he left.<br/><br/>So what does he tell Mr. Sanford the following day when those copies wind up on his boss's desk?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J.M. Snyder
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?12e77c7c